import React from 'react';

import { Flex, xcss } from '@atlaskit/primitives';
import { useIsNewNavigation } from '@atlassian/eoc-global-context';
import { Skeleton } from '@atlassian/eoc-skeleton';

const items = [
	{
		key: 'routing-rules',
		headerWidth: 22,
		sectionHeight: 8,
	},
	{
		key: 'escalation-policies',
		headerWidth: 28,
		sectionHeight: 12.5,
	},
	{
		key: 'schedule',
		headerWidth: 18,
		sectionHeight: 17.5,
	},
];

const oldContainerStyles = xcss({
	margin: '0 auto',
	maxWidth: '1280px',
	padding: 'space.300',
});

const containerStyles = xcss({
	padding: 'space.300',
});

const Loading: React.FC = () => {
	const isHorizontalNav = useIsNewNavigation();

	return (
		<Flex
			xcss={[isHorizontalNav ? containerStyles : oldContainerStyles]}
			direction="column"
			rowGap="space.600"
		>
			{items.map(({ key, headerWidth, sectionHeight }) => (
				<Flex key={key} direction="column" rowGap="space.200">
					<Flex alignItems="center" justifyContent="space-between">
						<Flex columnGap="space.100">
							<Skeleton variant="line" height={3} width={headerWidth} />
							<Skeleton variant="circle" height={3} width={3} />
						</Flex>
						<Skeleton variant="square" height={3} width={3} />
					</Flex>

					<Skeleton variant="line" height={sectionHeight} width="100%" />
				</Flex>
			))}
		</Flex>
	);
};

export { Loading };
